import React, { useState } from 'react';
import logo from "assets/images/welcome-logo.png";
import { Input, Label } from 'reactstrap';

const Airfreight = ({ reff, shipperData }) => {
    return (
        <div className="page-content" ref={reff}>
            <div className='' >
                <p>SHIPPER'S INSTRUCTIONS TO ARRANGE FOR SHIPMENT OF GOODS</p>
                <div className='print-layout'>
                    <table className='w-100 main-table'>
                        <tbody>
                            <tr>
                                <td className='left-col' style={{ padding: "0" }}>
                                    <table className='w-100'>
                                        <tr>
                                            <td>
                                                <table className='w-100'>
                                                    <tr>
                                                        <table className='p-3 w-100'>
                                                            <thead>
                                                                <tr>
                                                                    <td className='py-2 px-3'><p className='pr-heading'>Exporter (Shipper)</p></td>
                                                                </tr>
                                                            </thead>
                                                            <tr>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='pb-2 px-3'> <span className='cont-val'>{shipperData?.exporter}</span></td>
                                                                    </tr>
                                                                </tbody>

                                                            </tr>
                                                        </table>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "0" }} className="bt-line">
                                                <table className='w-100'>
                                                    <tr>
                                                        <table className='w-100'>
                                                            <thead>
                                                                <tr>
                                                                    <td className='py-2 px-3'><p className='pr-heading'>Consignee(If"Order" enter notify party in space below)</p></td>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                <tr>
                                                                    <td className='pb-2 px-3'> <span className='cont-val'>{shipperData?.consignee}</span></td>
                                                                </tr>
                                                            </tbody>


                                                        </table>
                                                    </tr>
                                                    <tr>
                                                        <table className='w-100 mx-3'>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <table>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className='cont-val head-color'>Telephone&#58;</td>
                                                                                    <td className='cont-val'>{shipperData?.consigneePhoneNumber}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                    <td>
                                                                        <table>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className='cont-val head-color'>Ctc person&#58;</td>
                                                                                    <td className='cont-val'>{shipperData?.consigneeCtcPerson}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "0" }} className="bt-line">
                                                <table className='w-100'>
                                                    <tr>
                                                        <table className='w-100'>
                                                            <thead>
                                                                <tr>
                                                                    <td className='py-2 px-3'><p className='pr-heading'>Notify Party (Only if not stated above:otherwise leave blank)</p></td>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                <tr>
                                                                    <td className='pb-2 px-3'> <span className='cont-val'>{shipperData?.notifyParty}</span></td>
                                                                </tr>
                                                            </tbody>


                                                        </table>
                                                    </tr>
                                                    <tr>
                                                        <table className='w-100 mx-3'>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <table>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className='cont-val head-color'>Telephone&#58;</td>
                                                                                    <td className='cont-val'>{shipperData?.notifyPartyPhoneNumber}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                    <td>
                                                                        <table>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className='cont-val head-color'>Ctc person&#58;</td>
                                                                                    <td className='cont-val'>{shipperData?.notifyPartyCtcPerson}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>

                                    <div className='b-top-bottom p-3 border-bottom-0 bt-line'>
                                        <table className='w-100'>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td><p className='pr-heading'>To (Airport of Destination)</p></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='cont-val'>{shipperData?.to}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                   
                                                </tr>
                                                <tr>
                                                <td className='pt-2'>
                                                        <table>
                                                            <tbody>
                                                                <tr><td><p className='pr-heading'>Airline Counter Signature </p></td></tr>
                                                                <tr>
                                                                    <td className='cont-val'>
                                                                        <div className='radio-group array-element mb-2'>
                                                                            <div className='radio-item'>
                                                                                <Input
                                                                                    checked={shipperData?.airLineCounterSignature === 'yes' ? true : false}
                                                                                    type="radio"
                                                                                    className="form-control"
                                                                                    onChange={() => { }}
                                                                                />
                                                                                <Label>Yes</Label>
                                                                            </div>
                                                                            <div className='radio-item'>
                                                                                <Input
                                                                                    checked={shipperData?.airLineCounterSignature === 'no' ? true : false}
                                                                                    type="radio"
                                                                                    className="form-control"
                                                                                    onChange={() => { }}
                                                                                />
                                                                                <Label>No</Label>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                                <td className='right-col'>
                                    <div className='company-info'>
                                        <h5>GLOTTIS PVT LTD</h5>
                                        <img src={logo} alt="GLOTTIS-logo" />
                                    </div>
                                    <div className='b-top-bottom p-3'>
                                        <div className='shipper-info'>
                                            <table>
                                                <tbody>
                                                    <tr><td><p className='pr-heading'>Airfreight charges</p></td></tr>
                                                    <tr>
                                                        <td className='cont-val'>
                                                            <div className='radio-group array-element mb-2'>
                                                                <div className='radio-item'>
                                                                    <Input
                                                                        checked={shipperData?.airFreightChargesPrepaid === 'prepaid' ? true : false}
                                                                        name="airFreightChargesPrepaid"
                                                                        type="checkbox"
                                                                        className="form-control"
                                                                        id="prepaid-airFreightCharges"
                                                                        onChange={() => { }}
                                                                    />
                                                                    <Label>To be prepaid</Label>
                                                                </div>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='cont-val'>
                                                            <div className='radio-group array-element mb-2'>

                                                                <div className='radio-item'>
                                                                    <Input
                                                                        checked={shipperData?.airFreightChargesCollected === 'collected' ? true : false}
                                                                        name="airFreightChargesCollected"
                                                                        type="checkbox"
                                                                        className="form-control"
                                                                        id="collected-airFreightCharges"
                                                                        onChange={() => { }}
                                                                    />
                                                                    <Label>To be collected (If service availabele)</Label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <table className='w-100'>
                                                <tbody>
                                                    <tr><td><p className='pr-heading'>Other charges</p></td></tr>
                                                    <tr>
                                                        <td className='cont-val'>
                                                            <div className='radio-group array-element mb-2'>
                                                                <div className='radio-item'>
                                                                    <Input
                                                                        checked={shipperData?.otherChargesPrepaid === 'prepaid' ? true : false}
                                                                        name="otherChargesPrepaid"
                                                                        type="checkbox"
                                                                        className="form-control"
                                                                        id="prepaid-otherCharges"
                                                                        onChange={() => { }}
                                                                    />
                                                                    <Label>To be prepaid</Label>
                                                                </div>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='cont-val'>
                                                            <div className='radio-group array-element mb-2'>

                                                                <div className='radio-item'>
                                                                    <Input
                                                                        checked={shipperData?.otherChargesCollected === 'collected' ? true : false}
                                                                        name="otherChargesCollected"
                                                                        type="checkbox"
                                                                        className="form-control"
                                                                        id="collected-otherCharges"
                                                                        onChange={() => { }}
                                                                    />
                                                                    <Label>To be collected (If service availabele)</Label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='b-top-bottom p-3 border-top-0'>
                                        <table className='w-100'>
                                            <tbody>
                                                <tr>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className='cont-val head-color'>Export Licence no. &#58;</td>
                                                                <td className='cont-val'>{shipperData?.exportLicenceNumber}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <table className='mt-2'>
                                                        <tbody>
                                                            <tr>
                                                                <td className='cont-val head-color'>C.O.No. &#58;	</td>
                                                                <td className='cont-val'>{shipperData?.cono}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='p-3 border-top'>
                                        <div className='shipper-info'>
                                            <p className='pr-heading'>special instructions</p>
                                            <span className='cont-val'>{shipperData?.specialInstructions}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='country-row'>
                        <table className='w-100'>
                            <tbody>
                                <tr>
                                    <td className='br-line ps-2'>
                                        <tr>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <p className='cont-val'>Country of Origin</p>
                                                            <span className='cont-val'>{shipperData?.countryOfOrigin}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </tr>
                                    </td>
                                    <td className='br-line ps-2'>
                                        <tr>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <p className='cont-val'>Shippers C.O.D.</p>
                                                            <span className='cont-val'>{shipperData?.shippersCOD}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </tr>
                                    </td>
                                    <td className='ps-2 br-line'>
                                        <tr>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <p className='cont-val'>Insurance Amount</p>
                                                            <span className='cont-val'>{shipperData?.insuranceAmount}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </tr>
                                    </td>
                                    <td className='w-25 ps-2 br-line'>
                                        <tr>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <p className='cont-val'>Declared Value For Carriage</p>
                                                            <span className='cont-val'>{shipperData?.declaredValueForCarriage}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </tr>
                                    </td>
                                    <td className='w-25 ps-2'>
                                        <tr>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <p className='cont-val'>Declared Value for Customs</p>
                                                            <span className='cont-val'>{shipperData?.declaredValueForCustomers}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </tr>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='packages-items'>
                        <table className='w-100'>
                            <thead>
                                <tr>
                                    <th className='child-one br-line'>Marks and no.s, no. and Kind of Packages, Description of Goods </th>
                                    <th className='child-two br-line'>GrossWeight</th>
                                    <th className='child-three'>Measurement</th>
                                </tr>
                            </thead>
                            <tbody>
                                {shipperData?.containerDetails?.map((item, index) => (
                                    <tr key={index}>
                                        <td className='cont-val br-line'>{item?.markAndSerialNumber} / {item?.kindOfPackages} / {item?.descriptionOfGoods}</td>
                                        <td className='cont-val br-line'>{item?.grossWeight}</td>
                                        <td className='cont-val'>{item?.measurements}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Airfreight;